var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#B4B8CF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9824 6.14867L9.85125 5.01747L2.40005 12.4687V13.5999H3.53125L10.9824 6.14867ZM12.1137 5.01747L13.2449 3.88627L12.1137 2.75507L10.9824 3.88627L12.1137 5.01747ZM4.19365 15.1999H0.800049V11.8055L11.548 1.05747C11.6981 0.907495 11.9015 0.823242 12.1137 0.823242C12.3258 0.823242 12.5292 0.907495 12.6793 1.05747L14.9424 3.32067C15.0924 3.47069 15.1767 3.67414 15.1767 3.88627C15.1767 4.0984 15.0924 4.30185 14.9424 4.45187L4.19445 15.1999H4.19365Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.86e6cb700dd624190ea2e51fa2f740f1.svg";
export { ForwardRef as ReactComponent };